export const PAYMENT_TYPE_CREDIT_CARD = 'payment-credit-card';
export const PAYMENT_TYPE_CASH = 'payment-cash';
export const PAYMENT_TYPE_SLIP = 'payment-slip';
